module.exports = {
      id: "audio-pause-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#audio-pause",
      toString: function () {
        return this.url;
      }
    }